<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
  >
    <g clip-path="url(#clip0_40002833_22930)">
      <path
        d="M9.99964 19.091C15.0204 19.091 19.0905 15.0209 19.0905 10.0001C19.0905 4.97932 15.0204 0.90918 9.99961 0.90918C5.92903 0.90918 2.5217 3.58454 1.36328 7.27282H3.63601"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10 6.36377V10.0001L11.8182 11.8183"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M0.90918 10C0.90918 10.3066 0.923002 10.6099 0.95003 10.9091M7.27282 19.0909C6.96227 18.9887 6.65891 18.8695 6.36372 18.7343M2.00863 14.5455C1.83331 14.2077 1.67693 13.8575 1.54097 13.4966M3.48302 16.6423C3.7609 16.9416 4.05741 17.222 4.37059 17.4811"
        stroke="currentColor"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_40002833_22930">
        <rect
          width="20"
          height="20"
          fill="currentColor"
        />
      </clipPath>
    </defs>
  </svg>
</template>
